import type { TFunction } from "i18next";
import type { FilterTab } from "@/partner/shared/components/FilterTabs";

export function getAnalyticsTabs(t: TFunction): FilterTab[] {
  return [
    {
      value: "views",
      label: t("analytics.tabs.views"),
      to: "/partner/analytics/views",
    },
    {
      value: "sales",
      label: t("analytics.tabs.sales"),
      to: "/partner/analytics/sales",
    },
    {
      value: "users",
      label: t("analytics.tabs.users"),
      to: "/partner/analytics/users",
    },
  ];
}
